import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "./Logo";
import { useLang } from "../context/LanguageContext";
import { LEGAL } from "../lib/legal";
import { START } from "../lib/inhalte";

export const Footer = () => {
  const { lang } = useLang();
  const legal = LEGAL[lang]?.common || LEGAL.de.common;
  const k = START.kontakt;
  return (
    <footer id="kontakt" data-testid="site-footer" className="bg-stein-200 border-t border-stein-300 pt-12 md:pt-16 pb-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
          <Logo gross />
          <div>
            <div className="text-sm font-semibold text-stein-900 mb-4">{k.label}</div>
            <ul className="space-y-3 text-stein-800">
              <li>
                <a href={`mailto:${k.email}`} className="inline-flex items-center gap-3 hover:text-chemara-violet">
                  <Mail size={16} /> {k.email}
                </a>
              </li>
              <li>
                <a href={`tel:${k.telefon_link}`} className="inline-flex items-center gap-3 hover:text-chemara-violet">
                  <Phone size={16} /> {k.telefon}
                </a>
              </li>
              <li className="flex items-start gap-3 whitespace-pre-line">
                <MapPin size={16} className="mt-1 shrink-0" /> {k.adresse}
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-6 border-t border-stein-300 flex flex-col md:flex-row md:justify-between gap-3 text-sm text-stein-500">
          <span>© {new Date().getFullYear()} Chemara GmbH</span>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-stein-900">{legal.privacy_link}</Link>
            <Link to="/imprint" data-testid="footer-imprint-link" className="hover:text-stein-900">{legal.imprint_link}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
